import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import tradetronWelcome from "./../../../Images/tradetronWelcome.png";
// import SmartOptionsHero from "./../../../Images/SmartOptions/SmartOptions-hero.png";
import SmartOptionsHero from "./../../../Images/SmartOptions/SmartOptionsHeroNew.png";
import AlgoBulls from './../../../Images/tools/algo-trading/single-page/AlgoBulls.png'
import "./SmartOptionsWelcome.css";
function SmartOptionsWelcome(props) {
  const title = props.data.title; // Assuming props.data.title is a string
  const splitIndex = title.indexOf('strategies with target & stoploss') + 'strategies with target & stoploss'.length;
  
  // Splitting the title into two parts based on the splitIndex
  const firstPart = title.slice(0, splitIndex).trim();
  const secondPart = title.slice(splitIndex).trim();
  return (
    <>
      <section className="SmartOptionsWelcome_section">
        <Container>
          <Row>
          <Col md={8} sm={7}>
              <div>
                <h3> Trade Options Directly from <br></br><span className="text-blue">Real Time Charts</span></h3>
                <p>One-stop solution for options trader & scalper. Select multiple indices and conveniently trade in options directly from charts with a single tap through basket trading.</p>
              </div>
            </Col>
            <Col md={4} sm={5}>
              <div className="SmartOptionsWelcome_img pl-3">
                <img
                  className="img-fluid"
                  src={SmartOptionsHero}
                  alt="SmartOptions"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default SmartOptionsWelcome;
